import React, { useState, useEffect } from "react";

export const ThemeInput = React.memo(
  ({
    themeName,
    onChange,
    className,
  }: {
    themeName: string;
    onChange: (oldT: string, newT: string) => void;
    className?: string;
  }) => {
    const [val, setVal] = useState(themeName);
    useEffect(() => {
      setVal(themeName);
    }, [themeName]);

    return (
      <input
        name="theme-editor"
        aria-label="Edit group theme name"
        value={val}
        onChange={(e) => setVal(e.target.value)}
        onBlur={(e) => {
          if (val.trim() && val !== themeName) {
            onChange(themeName, val.trim());
          } else {
            setVal(themeName);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.currentTarget.blur();
          }
        }}
        className={className}
      />
    );
  },
);
